import { register } from '@/js/global/shopify-theme-sections'
import { shouldAnimate } from '@/js/global/helpers'
import { animateListCollections } from '@/js/global/animations'

register("list-collections", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateListCollections = animateListCollections(this.container);
    }
  },
  onUnload() {
    var _this$animateListColl;
    (_this$animateListColl = this.animateListCollections) === null || _this$animateListColl === void 0 ? void 0 : _this$animateListColl.destroy();
  }
});
